export default __webpack_public_path__ + "locales/de/InviteDialog.json?hash=1b860b14efe780627c67ce5852ef49fd";